import Platform from 'platform'
import { StyledProps } from '@components/3rd-party/mui'
import React from 'react'
import { DragSource, DragSourceSpec } from 'react-dnd'
import { DragPreview } from './DragPreview'
import isBoolean from 'lodash/isBoolean'

const ItemTypes = {
  LIBRARYITEM: 'libraryItem'
}

const spec: DragSourceSpec<any, any> = {
  beginDrag(props) {
    return {
      ...props
    }
  },
  canDrag(props) {
    return isBoolean(props.canDrag) ? props.canDrag : true
  }
}

const collectDrag = (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
    clientOffset: monitor.getClientOffset() // Get mouse position during dragging
  }
}

interface MyProps extends StyledProps {
  connectDragSource?: (any) => React.ReactNode
  connectDragPreview?: (any) => React.ReactNode
  canDrag?: boolean
  isDragging?: boolean
  customDraggableChildren?: any
  dragPreviewRef?: any
  clientOffset?: { x: number; y: number }
  containerRef?: any
}

@((DragSource as any)(ItemTypes.LIBRARYITEM, spec, collectDrag))
export class CustomPreviewDraggableSource extends React.Component<MyProps & any> {
  private dragPreviewRef: React.RefObject<HTMLDivElement>

  constructor(props) {
    super(props)
    this.dragPreviewRef = React.createRef() // Ref to the draggable div for the custom preview
  }
  componentDidMount() {
    const { connectDragPreview } = this.props
    connectDragPreview(this.dragPreviewRef.current)
  }

  render() {
    const {
      props,
      props: {
        connectDragSource,
        children,
        className,
        canDrag,
        isDragging,
        customDraggableChildren,
        clientOffset,
        containerRef
      }
    } = this

    const position = containerRef?.current?.getBoundingClientRect()

    return connectDragSource(
      <div
        style={{
          WebkitTouchCallout: 'none'
        }}
      >
        <div className={className} style={{ opacity: isDragging ? 0.25 : 1 }}>
          {children}
        </div>
        {(Platform.os.family === 'iOS' || Platform.os.family === 'Android') && (
          <DragPreview {...props} />
        )}

        <div
          ref={this.dragPreviewRef} // Reference to the custom drag preview div
          style={{
            position: 'absolute',
            width: '100%',
            zIndex: -1,
            left: clientOffset ? `${clientOffset.x - position?.x}px` : '0px', // Dynamically move with cursor
            top: clientOffset
              ? `${clientOffset.y + containerRef.current?.scrollTop - position?.y}px`
              : '0px', // Dynamically move with cursor
            pointerEvents: 'none'
          }}
        >
          {canDrag ? customDraggableChildren : null}
        </div>
      </div>
    ) as React.ReactNode
  }
}
